import React from "react";
import { Inbox } from "lucide-react";

export default function EmptyState({ title = "Nothing here yet", description = "", action = null, icon: Icon = Inbox }) {
  return (
    <div className="border border-dashed border-border rounded-md p-10 flex flex-col items-center justify-center text-center bg-card/50">
      <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center mb-3">
        <Icon size={20} strokeWidth={1.75} />
      </div>
      <div className="font-display font-bold text-lg mb-1">{title}</div>
      {description && <div className="text-sm text-muted-foreground max-w-md">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
